import React, { useState, useEffect } from 'react'
import {
    Dialog,
    DialogContent,
    DialogTitle,
    useMediaQuery,
    Select,
    InputLabel,
    MenuItem,
    Alert,
    Tab,
    Tabs,
    Box
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Content, Campo, FormControlEspacado, InputLabelBranco } from './styles'
import axios from '../../../services/withAxios';
import Categoria from '../../../interfaces/categoria'
import Produto from '../../../interfaces/produto'
import PopupProps from '../../../interfaces/popupProps';
import ButtonsCrud from '../ButtonsCrud';
import { DesabilitarCampoCrud, EsconderPorNivelAcesso } from '../../../services/auth';
import { NivelAcessoEnum } from '../../../utils/enum/nivelAcessoEnum';
import { NumberFormatValues } from 'react-number-format';
import CurrencyInput from '../CurrencyInput';
import pagedGet from '../../../services/pagedGet'
import { FULL_LIST_PAGE_SIZE } from '../../../interfaces/pagedResult'

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    abaValue: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, abaValue, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={abaValue !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {abaValue === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const ProdutoDialog: React.FC<PopupProps<Produto>> = ({ aberto, setAberto, entidade }) => {
    const [aba, setAba] = useState<number>(0);

    const [codigo, setCodigo] = useState<string>('')
    const [codigoDeBarra, setCodigoDeBarra] = useState<string>('')
    const [nome, setNome] = useState<string>('')
    const [descricao, setDescricao] = useState<string>('')
    const [ncm, setNcm] = useState<string>('');
    const [valor, setValor] = useState<number>(0)
    const [valorCompra, setValorCompra] = useState<number>(0)
    const [categoriaSelecionada, setCategoriaSelecionada] = useState<string>()

    const [categorias, setCategorias] = useState<Categoria[]>()

    //Impostos
    const [pisCst, setPisCst] = useState<number>();
    const [pisAliquota, setPisAliquota] = useState<number>();
    const [cofinsCst, setCofinsCst] = useState<number>();
    const [cofinsAliquota, setCofinsAliquota] = useState<number>();
    const [icmsCsosn, setIcmsCsosn] = useState<string>('');
    const [icmsCst, setIcmsCst] = useState<string>('');
    const [icmsAliquota, setIcmsAliquota] = useState<number>();
    const [ipiCst, setIpiCst] = useState<string>('');
    const [ipiCodigoEnquadramento, setIpiCodigoEnquadramento] = useState<string>('');
    const [ipiAliquota, setIpiAliquota] = useState<number>();
    const [ibscbsCst, setIbscbsCst] = useState<number>();
    const [ibscbsClassTrib, setIbscbsClassTrib] = useState<number>();

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

    const handleFechar = () => {
        setAberto(false)
    }

    const handleSalvar = (e: React.SyntheticEvent) => {
        e.preventDefault()
        if (entidade) {
            axios.put('/produto', {
                id: entidade?.id,
                codigo: codigo.toUpperCase(),
                codigoDeBarra: codigoDeBarra.toUpperCase(),
                nome: nome.toUpperCase(),
                descricao: descricao.toUpperCase(),
                ncm,
                valor: valor as number,
                valorCompra: valorCompra as number,
                pisCst,
                pisAliquota,
                cofinsCst,
                cofinsAliquota,
                icmsCsosn: icmsCsosn || null,
                icmsCst: icmsCst || null,
                icmsAliquota,
                ipiCst: ipiCst || null,
                ipiCodigoEnquadramento: ipiCodigoEnquadramento || null,
                ipiAliquota,
                ibscbsCst,
                ibscbsClassTrib,
                categoriaId: categoriaSelecionada ?? '',
            } as Produto)
                .then(resp => {
                    if (resp.status === 200)
                        setAberto(false)
                })
        } else {
            axios.post('/produto', {
                codigo: codigo.toUpperCase(),
                codigoDeBarra: codigoDeBarra.toUpperCase(),
                nome: nome.toUpperCase(),
                descricao: descricao.toUpperCase(),
                ncm,
                valor: valor as number,
                valorCompra: valorCompra as number,
                pisCst,
                pisAliquota,
                cofinsCst,
                cofinsAliquota,
                icmsCsosn: icmsCsosn || null,
                icmsCst: icmsCst || null,
                icmsAliquota,
                ipiCst: ipiCst || null,
                ipiCodigoEnquadramento: ipiCodigoEnquadramento || null,
                ipiAliquota,
                categoriaId: categoriaSelecionada ?? '',
                ibscbsCst,
                ibscbsClassTrib
            } as Produto)
                .then(resp => {
                    if (resp.status === 200)
                        setAberto(false)
                })
        }
    }

    useEffect(() => {
        const buscarCategorias = async () => {
            const result = await pagedGet<Categoria>('/categoria', {
                page: 1,
                pageSize: FULL_LIST_PAGE_SIZE,
                params: { avoidLoadingScreen: true },
            })
            setCategorias(result.items)
        }

        if (entidade) {
            setCodigo(entidade.codigo)
            setNome(entidade.nome)
            setCodigoDeBarra(entidade.codigoDeBarra)
            setDescricao(entidade.descricao)
            setNcm(entidade.ncm)
            setPisCst(entidade.pisCst)
            setPisAliquota(entidade.pisAliquota)
            setCofinsCst(entidade.cofinsCst)
            setCofinsAliquota(entidade.cofinsAliquota)
            setIcmsCsosn(entidade.icmsCsosn ?? '')
            setIcmsCst(entidade.icmsCst ?? '')
            setIcmsAliquota(entidade.icmsAliquota ?? undefined)
            setIpiCst(entidade.ipiCst ?? '')
            setIpiCodigoEnquadramento(entidade.ipiCodigoEnquadramento ?? '')
            setIpiAliquota(entidade.ipiAliquota ?? undefined)
            setIbscbsCst(entidade.ibscbsCst)
            setIbscbsClassTrib(entidade.ibscbsClassTrib)
            setValor(entidade.valor)
            setValorCompra(entidade.valorCompra)
            setCategoriaSelecionada(entidade.categoriaId)
        }

        buscarCategorias()
    }, [aberto, entidade])

    const handleDeletar = () => {
        if (entidade?.id) {
            axios.delete('/produto/' + entidade.id).then(resp => {
                if (resp.status === 200)
                    setAberto(false)
                else {
                    return <Alert severity="error">Erro ao deletar produto</Alert>
                }
            })
        }
    }

    const handleAbaChange = (event: React.SyntheticEvent, valorAba: number) => {
        setAba(valorAba);
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            open={aberto}
            onClose={handleFechar}
        >
            <DialogTitle id="produto-dialog">
                {"Produto"}
            </DialogTitle>
            <DialogContent>
                <Content id="formProduto" component="form" onSubmit={handleSalvar}>
                    <TabPanel abaValue={aba} index={0}>
                        <Campo
                            id="codigo"
                            label="Código"
                            value={codigo}
                            onChange={(e) => setCodigo(e.target.value)}
                            fullWidth
                            autoComplete='off'
                            inputProps={{ style: { textTransform: "uppercase" } }}
                            autoFocus
                            disabled={DesabilitarCampoCrud()}
                        />
                        <Campo
                            id="codigo-barra"
                            label="Código de Barras"
                            value={codigoDeBarra}
                            onChange={(e) => setCodigoDeBarra(e.target.value)}
                            fullWidth
                            inputProps={{ style: { textTransform: "uppercase" } }}
                            autoComplete='off'
                            disabled={DesabilitarCampoCrud()}
                        />
                        <Campo
                            id="nome"
                            label="Nome"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            required
                            fullWidth
                            autoComplete='off'
                            inputProps={{ style: { textTransform: "uppercase" } }}
                            disabled={DesabilitarCampoCrud()}
                        />
                        <Campo
                            id="descricao"
                            label="Descrição"
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                            fullWidth
                            autoComplete='off'
                            inputProps={{ style: { textTransform: "uppercase" } }}
                            disabled={DesabilitarCampoCrud()}
                        />
                        <Campo
                            id="ncm"
                            label="Ncm"
                            value={ncm}
                            onChange={(e) => setNcm(e.target.value.replace(/\D/g, ''))}
                            fullWidth
                            autoComplete='off'
                            disabled={DesabilitarCampoCrud()}
                        />
                        <EsconderPorNivelAcesso nivelAcesso={[NivelAcessoEnum.admin, NivelAcessoEnum.gerente]}>
                            <FormControlEspacado focused variant='outlined' fullWidth>
                                <InputLabelBranco>Valor Compra</InputLabelBranco>
                                <CurrencyInput
                                    onValueChange={(v: NumberFormatValues) => setValorCompra(v.floatValue ?? 0)}
                                    value={valorCompra}
                                    required
                                    autoComplete='off'
                                />
                            </FormControlEspacado>
                        </EsconderPorNivelAcesso>
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <InputLabelBranco>Valor Venda</InputLabelBranco>
                            <CurrencyInput
                                onValueChange={(v: NumberFormatValues) => setValor(v.floatValue ?? 0)}
                                value={valor}
                                required
                                autoComplete='off'
                                disabled={DesabilitarCampoCrud()}
                            />
                        </FormControlEspacado>
                        <FormControlEspacado fullWidth>
                            <InputLabel id="categoria-label">Categoria</InputLabel>
                            <Select
                                labelId="categoria-label"
                                id="categoria"
                                value={categoriaSelecionada}
                                label="Categoria"
                                required
                                disabled={DesabilitarCampoCrud()}
                                onChange={(e: any) => setCategoriaSelecionada(e.target.value as string)}
                            >
                                {
                                    categorias?.map((item: Categoria) => {
                                        return <MenuItem key={item.id} value={item.id}>{item.nome}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControlEspacado>
                    </TabPanel>
                    <TabPanel abaValue={aba} index={1}>
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="pis-cst"
                                label="PIS CST"
                                value={pisCst}
                                onChange={(e) => setPisCst(parseFloat(e.target.value))}
                                fullWidth
                                type="number"
                                autoComplete='off'
                            />
                        </FormControlEspacado>
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="pis-aliquota"
                                label="PIS Aliquota (%)"
                                value={pisAliquota}
                                onChange={(e) => setPisAliquota(parseFloat(e.target.value))}
                                fullWidth
                                type="number"
                                autoComplete='off'
                            />
                        </FormControlEspacado>
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="cofins-cst"
                                label="COFINS CST"
                                value={cofinsCst}
                                onChange={(e) => setCofinsCst(parseFloat(e.target.value))}
                                fullWidth
                                type="number"
                                autoComplete='off'
                            />
                        </FormControlEspacado>
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="cofins-aliquota"
                                label="COFINS Aliquota (%)"
                                value={cofinsAliquota}
                                onChange={(e) => setCofinsAliquota(parseFloat(e.target.value))}
                                fullWidth
                                type="number"
                                autoComplete='off'
                            />
                        </FormControlEspacado>
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="icms-aliquota"
                                label="ICMS Aliquota (%)"
                                value={icmsAliquota}
                                onChange={(e) => setIcmsAliquota(parseFloat(e.target.value))}
                                fullWidth
                                type="number"
                                autoComplete='off'
                            //disabled={DesabilitarCampoCrud()}
                            />
                        </FormControlEspacado>
                        {/* Campos abaixo sao opcionais: em branco, vale o preset da Configuracao Fiscal. */}
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="icms-csosn"
                                label="ICMS CSOSN (vazio = usar preset)"
                                value={icmsCsosn}
                                onChange={(e) => setIcmsCsosn(e.target.value)}
                                fullWidth
                                autoComplete='off'
                            />
                        </FormControlEspacado>
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="icms-cst"
                                label="ICMS CST - Regime Normal (vazio = usar preset)"
                                value={icmsCst}
                                onChange={(e) => setIcmsCst(e.target.value)}
                                fullWidth
                                autoComplete='off'
                            />
                        </FormControlEspacado>
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="ipi-cst"
                                label="IPI CST (vazio = usar preset)"
                                value={ipiCst}
                                onChange={(e) => setIpiCst(e.target.value)}
                                fullWidth
                                autoComplete='off'
                            />
                        </FormControlEspacado>
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="ipi-cenq"
                                label="IPI cEnq (vazio = usar preset)"
                                value={ipiCodigoEnquadramento}
                                onChange={(e) => setIpiCodigoEnquadramento(e.target.value)}
                                fullWidth
                                autoComplete='off'
                            />
                        </FormControlEspacado>
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="ipi-aliquota"
                                label="IPI Aliquota (%)"
                                value={ipiAliquota}
                                onChange={(e) => setIpiAliquota(parseFloat(e.target.value))}
                                fullWidth
                                type="number"
                                autoComplete='off'
                            />
                        </FormControlEspacado>
                        <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="ibscbs-cst"
                                label="IBS/CBS CST"
                                value={ibscbsCst}
                                onChange={(e) => setIbscbsCst(parseInt(e.target.value))}
                                fullWidth
                                type="number"
                                autoComplete='off'
                            //disabled={DesabilitarCampoCrud()}
                            />
                        </FormControlEspacado>
                                                <FormControlEspacado focused variant='outlined' fullWidth>
                            <Campo
                                id="ibscbs-classtrib"
                                label="IBS/CBS Class. Trib."
                                value={ibscbsClassTrib}
                                onChange={(e) => setIbscbsClassTrib(parseInt(e.target.value))}
                                fullWidth
                                type="number"
                                autoComplete='off'
                            //disabled={DesabilitarCampoCrud()}
                            />
                        </FormControlEspacado>
                    </TabPanel>
                    <Tabs
                        value={aba}
                        onChange={handleAbaChange}
                    >
                        <Tab label="Produtos" />
                        <Tab label="Impostos" />
                    </Tabs>
                </Content>
            </DialogContent>
            <ButtonsCrud entidade={entidade} form={'formProduto'} handleDeletar={handleDeletar} handleFechar={handleFechar} handleSalvar={handleSalvar} />
        </Dialog>
    )
}

export default ProdutoDialog
